import { lazy, Suspense } from "react";
import { createBrowserRouter, Link } from "react-router";
import { Spin } from "antd";
const AdminPage=lazy(()=>import("../features/shixiangji/AdminPage").then(m=>({default:m.AdminPage})));
const AccessPage=lazy(()=>import("../features/shixiangji/AccessPage").then(m=>({default:m.AccessPage})));
const admin=<Suspense fallback={<Spin fullscreen/>}><AdminPage/></Suspense>;
/** 浏览器仅提供管理后台；用户端由 apps/mobile 的 React Native 页面承载。 */
export const router=createBrowserRouter([
  {path:"/",element:admin},
  {path:"/admin",element:admin},
  {path:"/access",element:<Suspense fallback={<Spin fullscreen/>}><AccessPage/></Suspense>},
  {path:"*",element:<main style={{padding:40}}><h1>识相集管理后台</h1><p>创作功能请在识相集 App 中使用。</p><Link to="/admin">返回管理后台</Link></main>},
]);
